import React from "react";
import { exact, number, string } from "prop-types";
import styles from "./SchoolGroupsAttendanceRow.module.styl";
import Chart from "react-apexcharts";
import { percentageLevels } from "utils/indicator/indicatorSettings.js";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";

export default function SchoolGroupsAttendanceRow({ groupAttendance, sportOrgUrl, schoolId }) {
    const indicatorStyle = percentageLevels.indicatorColor(groupAttendance.attendancePercent);
    const options = chartOptions(indicatorStyle);
    const series = [groupAttendance.attendancePercent];

    return (
        <div className={styles.row}>
            <a
                href={`${sportOrgUrl}/schools/${schoolId}/groups/${groupAttendance.groupId}/journal `}
                target="_blank"
                rel="noreferrer"
                data-test-name={`group_${groupAttendance.groupId}_report`}
                className={styles.groupCode}
            >
                {groupAttendance.groupCode}
            </a>
            <div className={styles.sportType}>{groupAttendance.sportType}</div>
            <div className={styles.sportTraining}>
                {groupAttendance.sportTrainingLevel}-{groupAttendance.sportTrainingYear}
            </div>
            <div className={styles.coachName}>{groupAttendance.coachName.lastNameAndInitials}</div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

SchoolGroupsAttendanceRow.propTypes = {
    groupAttendance: exact({
        groupId: number.isRequired,
        groupCode: string.isRequired,
        sportType: string.isRequired,
        sportTrainingLevel: string,
        sportTrainingYear: number.isRequired,
        coachName: exact({
            lastName: string.isRequired,
            firstName: string.isRequired,
            middleName: string,
            shortName: string.isRequired,
            fullName: string.isRequired,
            officialShortName: string.isRequired,
            officialFullName: string.isRequired,
            lastNameAndInitials: string.isRequired,
            firstNameAndMiddleName: string.isRequired,
        }),
        attendancePercent: number.isRequired,
    }),
    sportOrgUrl: string.isRequired,
    schoolId: number.isRequired,
};
